import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useCurrentUser } from "../../../context/user/UserContext"

function IsUsStep({ viewName }): JSX.Element {
  const { isUsa } = useCurrentUser()
  const { setNextStep } = useStateMachine(viewName, isUsa ? "YES" : "NO")
  useEffect(() => {
    setNextStep(viewName, isUsa ? "YES" : "NO")
  })
  return <></>
}

function UsMostHelpfulIsUsStep(): JSX.Element {
  return <IsUsStep viewName={Steps.US_MOST_HELPFUL} />
}

function GestationalCarrierIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.GESTATIONAL_CARRIER_IS_US_DECISION} />
}

function AdoptionIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.ADOPTION_IS_US_DECISION} />
}

function LGBTQPlusIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.LGBTQ_PLUS_IS_US_DECISION} />
}

function FertilityPreservationIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.FERTILITY_PRESERVATION_IS_US_DECISION} />
}

function AssistedReproductionIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.ASSISTED_REPRODUCTION_IS_US_DECISION} />
}

function AttemptingToGetPregnantIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.ATTEMPTING_TO_GET_PREGNANT_IS_US_DECISION} />
}

function CurrentlyPregnantIsUsDecisionStep(): JSX.Element {
  return <IsUsStep viewName={Steps.CURRENTLY_PREGNANT_IS_US_DECISION} />
}

export {
  UsMostHelpfulIsUsStep,
  GestationalCarrierIsUsDecisionStep,
  AdoptionIsUsDecisionStep,
  LGBTQPlusIsUsDecisionStep,
  FertilityPreservationIsUsDecisionStep,
  AssistedReproductionIsUsDecisionStep,
  AttemptingToGetPregnantIsUsDecisionStep,
  CurrentlyPregnantIsUsDecisionStep
}
